export default "__VITE_ASSET__Dk_TTzJ3__ 500w";